import React, { Component } from 'react';



class Footer extends Component {





  /*  <Link to={'/'}>HOME</Link>
    <i className="separator">l</i>
    <Link to={'/about'}>ABOUT</Link>
    <i className="separator">l</i>
    <a href="#videos">VIDEOS</a>
    <i className="separator">l</i>
    <a href="#photos">PHOTOS</a>
    <i className="separator">l</i>
    <a href="#live">LIVE</a>
    <i className="separator">l</i>
    <a href="#gear">GEAR</a>
    <i className="separator">l</i>
    <a href="#quotes">QUOTES</a>
    <i className="separator">l</i>
    <a href="#lessons">LESSONS</a>
    <i className="separator">l</i>
    <a href="#sessions">SESSIONS</a> */

  render() {
    return (
    <div className="footer">
          <p>© 2018 PATRIK SAS | All rights reserved.</p>
          <p className="textRight">Created by Jan Petřík, Studio Plesná 2018</p>

    </div>
  );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Footer.js